/* ========================================================
   SHIFT & SPARK · Shopify theme JS
   Cart wiring uses the Shopify AJAX cart API.
   Card renderers (mini-card front + back) ported from
   the static prototype.
   ======================================================== */
(function () {
  'use strict';

  // ---------- HTML escape helper ----------
  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }

  // ---------- SVG marks ----------
  var BOLT =
    '<svg viewBox="0 0 10 14" fill="currentColor" width="14" height="18">' +
    '<path d="M6.5 0L0 8.5h4.5L3.5 14 10.5 5.5H6V0z"/></svg>';
  var ARROWS =
    '<svg viewBox="0 0 14 9" fill="none" stroke="currentColor" stroke-width="2.2" ' +
    'stroke-linecap="round" stroke-linejoin="round" width="18" height="14">' +
    '<line x1="0" y1="2.5" x2="10" y2="2.5"/>' +
    '<polyline points="7,0 10,2.5 7,5"/>' +
    '<line x1="0" y1="6.5" x2="10" y2="6.5"/>' +
    '<polyline points="7,4 10,6.5 7,9"/></svg>';

  // ---------- Shopify cart (AJAX API) ----------
  // Docs: https://shopify.dev/docs/api/ajax/reference/cart
  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }
  function addToCart(variantId, qty, properties) {
    var body = {
      items: [{
        id: parseInt(variantId, 10),
        quantity: qty || 1,
        properties: properties || undefined,
      }],
    };
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify(body),
    }).then(function (r) {
      if (!r.ok) {
        return r.json().then(function (err) { throw err; });
      }
      return r.json();
    }).then(function (added) {
      return fetchCart().then(function (cart) {
        updateCartUI(cart);
        flashCart();
        document.dispatchEvent(new CustomEvent('ss:cart-updated', { detail: cart }));
        return cart;
      });
    });
  }
  function updateLine(lineKey, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: quantity }),
    }).then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartUI(cart);
        document.dispatchEvent(new CustomEvent('ss:cart-updated', { detail: cart }));
        return cart;
      });
  }
  function clearCart() {
    return fetch('/cart/clear.js', { method: 'POST' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartUI(cart); return cart; });
  }
  function fmtMoney(cents) {
    // Shopify Money in cents. Fall back to $XX.XX if no formatter present.
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function updateCartUI(cart) {
    var count = cart && cart.item_count ? cart.item_count : 0;
    document.querySelectorAll('[data-ss-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : '';
    });
  }
  function flashCart() {
    document.querySelectorAll('[data-ss-cart-count]').forEach(function (el) {
      try {
        el.animate(
          [{ transform: 'scale(1)' }, { transform: 'scale(1.4)' }, { transform: 'scale(1)' }],
          { duration: 380, easing: 'cubic-bezier(.4,1.6,.4,1)' }
        );
      } catch (e) { /* no-op */ }
    });
  }

  // ---------- Mini-card renderer (matches printed-card design) ----------
  function renderMiniCard(c, isShift) {
    var steps = (c.steps || []).slice(0, 3).map(function (s, i) {
      return (
        '<div class="mc-step">' +
          '<div class="mc-num">' + (i + 1) + '</div>' +
          '<div class="mc-stepb"><b>' + escapeHtml(s.label) + ':</b> ' +
            escapeHtml(s.text) + '</div>' +
        '</div>'
      );
    }).join('');
    var energy = c.energy_n || (isShift ? 1 : 3);
    var edots = [1, 2, 3].map(function (i) {
      return '<div class="mc-edot' + (i <= energy ? ' on' : '') + '"></div>';
    }).join('');
    var energyLbl = energy === 3 ? 'High energy' : energy === 1 ? 'Low energy' : 'Medium energy';
    var subjects = c.subjects || c.bestfor || 'All subjects';
    var act = (c.activity_type || '').replace(/\s*[·•]?\s*(Te Reo|TE REO).*/i, '').trim();
    var meaning = (c.meaning || '').toUpperCase();
    var subjEg = c.subject_example
      ? '<div class="mc-subj">' + escapeHtml(c.subject_example) + '</div>'
      : '';
    return (
      '<div class="mini-card' + (isShift ? ' is-shift' : '') + '">' +
        '<div class="mc-deco d1"></div>' +
        '<div class="mc-deco d2"></div>' +
        '<div class="mc-deco d3"></div>' +
        '<div class="mc-inner">' +
          '<div class="mc-top">' +
            '<div class="mc-badge">' +
              '<span style="display:flex">' + (isShift ? ARROWS : BOLT) + '</span> ' +
              (isShift ? 'SHIFT' : 'SPARK') +
            '</div>' +
            '<div class="mc-id">#' + escapeHtml(c.id) + '</div>' +
          '</div>' +
          '<div class="mc-title">' + escapeHtml(c.title) + '</div>' +
          '<div class="mc-sub">' + escapeHtml(act) + ' &nbsp;·&nbsp; TE REO: <em>' +
            escapeHtml(c.tereo || '') + '</em>' +
            (meaning ? ' (' + escapeHtml(meaning) + ')' : '') +
          '</div>' +
          '<div class="mc-steps">' + '<div class="mc-steps-list">' + steps + '</div>' + subjEg + '</div>' +
          '<div class="mc-tags">' +
            '<div class="mc-tag">' + escapeHtml(subjects) + '</div>' +
            '<div class="mc-tag">' + escapeHtml(c.time || '') + '</div>' +
            '<div class="mc-tag">' + escapeHtml(c.materials || '') + '</div>' +
          '</div>' +
          '<div class="mc-energy">' +
            '<div class="mc-edots">' + edots + '</div>' +
            '<div class="mc-elbl">' + energyLbl + '</div>' +
          '</div>' +
        '</div>' +
        '<div class="mc-foot">' +
          '<div class="mc-foot-lbl">Teacher Look-Fors</div>' +
          '<div class="mc-foot-text">' + escapeHtml(c.lookfors || '') + '</div>' +
        '</div>' +
      '</div>'
    );
  }

  function renderCardBack(c, isShift) {
    var desc = isShift
      ? 'CALM FOCUS · DEEP REFLECTION<br>METACOGNITION &amp; SELF-REGULATION'
      : 'HIGH ENERGY · ACTIVE ENGAGEMENT<br>RETRIEVAL &amp; COMPETITION';
    var iconBig = isShift
      ? '<svg width="36" height="22" viewBox="0 0 14 9" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><line x1="0" y1="2.5" x2="10" y2="2.5"/><polyline points="7,0 10,2.5 7,5"/><line x1="0" y1="6.5" x2="10" y2="6.5"/><polyline points="7,4 10,6.5 7,9"/></svg>'
      : '<svg width="26" height="36" viewBox="0 0 10 14" fill="currentColor"><path d="M6.5 0L0 8.5h4.5L3.5 14 10.5 5.5H6V0z"/></svg>';
    return (
      '<div class="mini-card is-back' + (isShift ? ' is-shift' : '') + '">' +
        '<div class="bk-id">#' + escapeHtml(c.id || '') + '</div>' +
        '<div class="bk-top">' +
          '<div class="bk-icon">' + iconBig + '</div>' +
          '<div class="bk-name">' + (isShift ? 'SHIFT' : 'SPARK') + '</div>' +
          '<div class="bk-rule"></div>' +
          '<div class="bk-desc">' + desc + '</div>' +
        '</div>' +
        '<div class="bk-lower">' +
          '<div class="bk-why-lbl">Why It Works</div>' +
          '<div class="bk-why-text">' + escapeHtml(c.why || '') + '</div>' +
          (c.research_ref ? '<div class="bk-nzc">Research: ' + escapeHtml(c.research_ref) + '</div>' : '') +
          '<div class="bk-ukd">Command word · ' + escapeHtml(c.command || 'Explain') + '</div>' +
        '</div>' +
      '</div>'
    );
  }

  // ---------- Auto-init ----------
  document.addEventListener('DOMContentLoaded', function () {
    // Sync the count badge with whatever Liquid rendered server-side
    fetchCart().then(updateCartUI);

    // Wire any data-ss-add-to-cart button
    document.querySelectorAll('[data-ss-add-to-cart]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var variantId = btn.dataset.variantId;
        var qty = parseInt(btn.dataset.qty || '1', 10);
        if (!variantId) return;
        btn.disabled = true;
        var orig = btn.textContent;
        btn.textContent = 'Adding…';
        addToCart(variantId, qty)
          .then(function () {
            btn.textContent = 'Added ✓';
            setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 1400);
          })
          .catch(function (err) {
            console.error(err);
            btn.textContent = err.description || 'Could not add';
            setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 2200);
          });
      });
    });

    // Wire any quantity stepper / line item in cart page
    document.querySelectorAll('[data-ss-cart-qty]').forEach(function (input) {
      input.addEventListener('change', function () {
        var line = parseInt(input.dataset.line, 10);
        var qty = Math.max(0, parseInt(input.value, 10) || 0);
        updateLine(line, qty).then(function () { window.location.reload(); });
      });
    });
    document.querySelectorAll('[data-ss-cart-remove]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var line = parseInt(btn.dataset.line, 10);
        updateLine(line, 0).then(function () { window.location.reload(); });
      });
    });

    // FAQ accordion
    document.querySelectorAll('[data-ss-faq] .faq-q').forEach(function (q) {
      q.addEventListener('click', function () {
        var item = q.closest('.faq-item');
        var open = item.classList.toggle('is-open');
        q.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  });

  // ---------- Expose globally ----------
  window.SS = {
    BOLT: BOLT,
    ARROWS: ARROWS,
    escapeHtml: escapeHtml,
    renderMiniCard: renderMiniCard,
    renderCardBack: renderCardBack,
    fetchCart: fetchCart,
    addToCart: addToCart,
    updateLine: updateLine,
    clearCart: clearCart,
    fmtMoney: fmtMoney,
  };
})();
